
import React from 'react'
import { FaChevronDown } from 'react-icons/fa';
import "../../styles/scroll-btn.scss";

export default function ScrollBtn() {
    return (
        <div className="scroll-btn-container">
         <FaChevronDown className="scroll-button"/> 
         </div>
    )
}
